import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { DropdownToggle as DropdownToggleComponent } from '@prisjakt/ui/dropdown';
import { ButtonText } from '@prisjakt/ui/button';

export const VariantGridHeader = styled.div`
  display: grid;
  margin-bottom: 0.5rem;
`;

export const VariantGridTitle = styled.div`
  grid-column: span 4;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const DropdownToggle = styled(DropdownToggleComponent)`
  width: auto;
  min-width: 206px;
`;

export const DropdownButtonText = styled(ButtonText)`
  text-align: left;
`;

export const SelectionHighlightedText = styled.span`
  color: ${p => p.theme.colors.maybeBlue700};
`;

export const ScrollableArea = styled.div`
  ${media.mediumUp`
    max-height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 1px;
  `}
`;
